/* import __COLOCATED_TEMPLATE__ from './devices-list-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class DevicesListCardComponent extends Component 
{
	@service store;
	
	@action
	selectEvent(device,event)
	{
		device.EventId = event;
		device.IntermediateTimingPointId = null;
		device.save();
	};
	
	@action
	selectTimingPoint(device,timingPointId)
	{
		device.IntermediateTimingPointId = timingPointId;
		device.save();
	};
	
	@action
	toggleCreateStartRecord(device,changeEvent)
	{
		device.shouldCreateStartRecord = changeEvent.target.checked;
		device.save();
	};
	
	@action
	toggleCreateFinishRecord(device,changeEvent)
	{
		device.shouldCreateFinishRecord = changeEvent.target.checked;
		device.save();
	};
	
	@action
	toggleCreateFinishPlungerRecord(device,changeEvent)
	{
		device.shouldCreateFinishPlungerRecord = changeEvent.target.checked;
		device.save();
	};
	
	@action
	toggleCreateFinishBibRecord(device,changeEvent)
	{
		device.shouldCreateFinishBibRecord = changeEvent.target.checked;
		device.save();
	};
	
	@action
	toggleCreateIntermediateRecord(device,changeEvent)
	{
		device.shouldCreateIntermediateTimingRecord = changeEvent.target.checked;
		device.save();
	};

	@action
	toggleCreateFinishOnLastLap(device,changeEvent)
	{
		device.shouldCreateFinishOnLastLap = changeEvent.target.checked;
		device.save();
	};
};